import {
    AdjustmentsHorizontalIcon,
    BuildingOffice2Icon,
    Cog6ToothIcon,
    DocumentTextIcon
} from '@heroicons/react/24/outline';
import { DETAIL_SECTIONS, type DetailSectionId } from './orthodontistDetailSections';

const SECTION_ICONS: Record<DetailSectionId, typeof BuildingOffice2Icon> = {
    info: BuildingOffice2Icon,
    files: DocumentTextIcon,
    beta: Cog6ToothIcon,
    preferences: AdjustmentsHorizontalIcon
};

interface OrthodontistDetailNavProps {
    activeId: DetailSectionId;
    onSelect: (id: DetailSectionId) => void;
}

// Left rail for the Details tab, trimmed from practice's DetailNav - no
// completeness meter, since this view has no editable or required fields.
export function OrthodontistDetailNav({ activeId, onSelect }: OrthodontistDetailNavProps) {
    return (
        <nav className="w-[200px] shrink-0 min-h-0 overflow-y-auto scrollbar-hide flex flex-col gap-1 bg-white border border-gray-200 rounded-xl shadow-[0px_1px_2px_rgba(0,0,0,0.06)] p-2">
            {DETAIL_SECTIONS.map((section) => {
                const isActive = section.id === activeId;
                const Icon = SECTION_ICONS[section.id];
                return (
                    <button
                        key={section.id}
                        type="button"
                        onClick={() => onSelect(section.id)}
                        aria-current={isActive ? 'page' : undefined}
                        className={`h-10 px-3 rounded-lg flex items-center gap-2.5 text-left transition-colors ${
                            isActive ? 'bg-gray-900 text-white' : 'text-gray-600 hover:bg-gray-100'
                        }`}
                    >
                        <Icon
                            className={`h-4 w-4 shrink-0 ${isActive ? 'text-white' : 'text-gray-400'}`}
                        />
                        <span className="text-[13px] font-semibold flex-1 truncate">
                            {section.label}
                        </span>
                    </button>
                );
            })}
        </nav>
    );
}
